import { render, staticRenderFns } from "./SubscriptionAnomaly.vue?vue&type=template&id=35861428"
import script from "./SubscriptionAnomaly.vue?vue&type=script&lang=js"
export * from "./SubscriptionAnomaly.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionAnomaly.vue?vue&type=style&index=0&id=35861428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports